// Holds factory providers of Angularjs services temporarily until they are upgraded to Angular.
// https://angular.io/guide/upgrade#making-angularjs-dependencies-injectable-to-angular
import EquipmentInfoService from '../components/base/infoServices/EquipmentInfoService';
import EventInfoService from '../components/base/infoServices/EventInfoService';
import DashboardInfoService from '../components/base/infoServices/DashboardInfoService';
import RcuInfoService from '../components/base/infoServices/RcuInfoService';
import UserInfoService from '../components/base/infoServices/UserInfoService';
import OrganizationService from '../core/services/organization.service';
import GroupService from '../components/admin/groups/GroupService';
import GroupsButtonService from '../components/base/GroupsButton/GroupsButtonService';
export const dashboardInfoServiceFactory = i => i.get('DashboardInfoService');
export const equipmentInfoServiceFactory = i => i.get('EquipmentInfoService');
export const eventInfoServiceFactory = i => i.get('EventInfoService');
export const rcuInfoServiceFactory = i => i.get('RcuInfoService');
export const userInfoServiceFactory = i => i.get('UserInfoService');
export const organizationServiceFactory = i => i.get('Organization');
export const dashboardInfoServiceProvider = {
    provide: DashboardInfoService,
    useFactory: dashboardInfoServiceFactory,
    deps: ['$injector']
};
export const equipmentInfoServiceProvider = {
    provide: EquipmentInfoService,
    useFactory: equipmentInfoServiceFactory,
    deps: ['$injector']
};
export const eventInfoServiceProvider = {
    provide: EventInfoService,
    useFactory: eventInfoServiceFactory,
    deps: ['$injector']
};
export const rcuInfoServiceProvider = {
    provide: RcuInfoService,
    useFactory: rcuInfoServiceFactory,
    deps: ['$injector']
};
export const userInfoServiceProvider = {
    provide: UserInfoService,
    useFactory: userInfoServiceFactory,
    deps: ['$injector']
};
export const groupServiceFactory = i => i.get('GroupService');
export const groupServiceProvider = {
    provide: GroupService,
    useFactory: groupServiceFactory,
    deps: ['$injector']
};
export const groupsButtonServiceFactory = i => i.get('GroupsButtonService');
export const groupsButtonServiceProvider = {
    provide: GroupsButtonService,
    useFactory: groupsButtonServiceFactory,
    deps: ['$injector']
};
export const organizationServiceProvider = {
    provide: OrganizationService,
    useFactory: organizationServiceFactory,
    deps: ['$injector']
};
export const modalServiceFactory = i => i.get('ModalService');
export const modalServiceProvider = {
    provide: 'ModalService',
    useFactory: modalServiceFactory,
    deps: ['$injector']
};
